import { makeStyles } from '@material-ui/core/styles';

const useTrafficStyles = makeStyles(theme => ({
    root: {
        fontSize: theme.typography.body1.fontSize,
        margin: '1rem 0'
    },
    modal: {
        width: '50%',
        height: '80%',
        overflowY: 'scroll',

        '& .MuiGrid-grid-xs-true': {
            marginTop: '1rem',
            textAlign: 'center'
        }
    },
    smallModal: {
        width: '50%',
        maxHeight: '80%',
        overflowY: 'scroll',

        '& .MuiGrid-grid-xs-true': {
            marginTop: '1rem',
            textAlign: 'center'
        }
    },
    headerBox: {
        margin: theme.spacing(1, 1, 4),

        '& .MuiTypography-root': {
            whiteSpace: 'nowrap',
            paddingBottom: 7,
        },
        '& .MuiAutocomplete-root': {
            width: '100%',
            marginBottom: 0,
        },
        '& .MuiTextField-root': {
            width: '100%',
            marginBottom: 0,
        },
    },
    header: {
        display: 'flex',
        alignItems: 'flex-end',
        minHeight: theme.spacing(14),

        '& .MuiTypography-body1': {
            marginRight: '0.5rem'
        }
    },
    headerButtons: {
        justifyContent: 'flex-end',
        '& .MuiButton-root': {
            marginRight: '0.5rem'
        }
    },
    panelBox: {
        borderRadius: theme.spacing(1),
        padding: theme.spacing(4, 3, 2),
        height: "100%",
    },
    sectionBox: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        flexWrap: "wrap",
        textAlign: 'left',
        padding: "0"
    },
    sectionItem: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        flexDirection: "column",
        padding: theme.spacing(0, 1, 4),
        '& strong': {
            marginBottom: '0.5rem'
        },
        '& .MuiAutocomplete-root': {
            width: '100%'
        },
        '& .MuiTextField-root': {
            width: '100%'
        },
    },
    rowDiff: {
        '& .MuiTypography-root': {
            marginBottom: theme.spacing(2),
        },
        '& .MuiGrid-root.MuiGrid-item': {
            borderLeft: '1px solid #EBEBEB',
            textAlign: 'center',
            padding: theme.spacing(1),

            '&:nth-child(3n+1)': {
                borderColor: 'transparent',
                textAlign: 'left',
                fontWeight: 600,
            }
        }
    },
    rowDiffSectionHeader: {
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
        padding: theme.spacing(1),
        margin: theme.spacing(2, 0),

        '& .MuiTypography-root': {
            marginBottom: 0,
            fontWeight: 600,
        },
    },
    rowDiffHighlight: {
        backgroundColor: theme.palette.warning.light,
        border: `1px solid ${theme.palette.warning.main}`,
        color: theme.palette.warning.dark,
        fontWeight: 600,
        marginBottom: -1,
    },
    defaultTrafficSource: {
        display: "flex",
    }
}));

export default useTrafficStyles;
